/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2022
 * @flow
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PopupHeader from '../../../../components/PopupHeader';
import Button from '../../../../components/Button';
import { CountryPicker, getPickerData } from "../../../../components/CountryPicker";
import FireboardUtils from '../../../../util/fireboard-util';
import strings from '../../../../globalization';
import classes from './UpdateGuestPhoneNumber.module.css';

const UpdateGuestPhoneNumber = ({ onClose, iso2, selectedCheck, onUpdateGuestInformation }) => {
  const [selectedCountry, setSelectedCountry] = useState({});
  const [phoneNumber, setPhoneNumber] = useState('');
  const [guestName, setGuestName] = useState('');
  const { data: storeInfo } = useSelector(state => state.storeInfo);

  useEffect(() => {
    let orderCountryCode;
    let orderPhoneNumber;
    if (selectedCheck && Object.keys(selectedCheck).length !== 0 && selectedCheck.constructor === Object) {
      const { orders } = selectedCheck || {};
      const [order0] = orders || [];
      orderCountryCode = order0?.countryCode;
      orderPhoneNumber = order0?.phoneNumber;
    }
    const storeCountryCode = storeInfo?.countryCode;
    const countryCode = orderCountryCode || storeCountryCode;
    const countriesData = getPickerData();
    if (countryCode) {
      const defaultCountry = countriesData.find(country => country.dialCode.split('+')[1] === countryCode);
      setSelectedCountry(defaultCountry);
    } else {
      //this will execute only if orders[0]->countryCode && storeInfo->countryCode both are blank or null
      const defaultCountry = countriesData.find(country => country.iso2 === String(iso2).toLowerCase());
      setSelectedCountry(defaultCountry);
    }
    if (orderPhoneNumber)
      setPhoneNumber(orderPhoneNumber || '');
  }, []);

  const onCountryChange = country => setSelectedCountry(country);

  const onSubmit = () => {
    const payload = {
      countryCode: selectedCountry.dialCode.split('+')[1],
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      guestName: guestName,
    };
    onUpdateGuestInformation && onUpdateGuestInformation(payload);
  };

  const isDisabled = () => {
    if (FireboardUtils.isObjectBlank(selectedCountry) ||
      FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2).length < 10)
      return true;
    return false;
  };

  return (
    <div className={classes.container}>
      <PopupHeader title={strings.updatePhoneNumber} onClose={onClose} titleStyle={classes.titleStyle} />
      <div className={classes.contentWrapper}>
        <div className={classes.inputWrapper}>
          <label className={classes.label}>{strings.optionalGuestName}</label>
          <input
            type={'text'}
            value={guestName}
            onChange={event => setGuestName(event.target.value)}
            className={classes.input}
          />
        </div>
        <div className={classes.inputWrapper}>
          <label className={classes.label}>{strings.countryCode}</label>
          <CountryPicker
            containerStyle={classes.countryPicker}
            selectedCountry={selectedCountry}
            onCountryChange={onCountryChange} />
        </div>
        <div className={classes.inputWrapper}>
          <label className={classes.label}>{strings.placeholderPhone}</label>
          <input
            type={'tel'}
            value={FireboardUtils.inputFormattedPhnNum(phoneNumber, selectedCountry?.iso2)}
            onChange={event => setPhoneNumber(event.target.value)}
            className={classes.input}
          />
        </div>
        <Button className={classes.button} onClick={onSubmit} disabled={isDisabled()}>
          <span className={classes.buttonText}>{strings.updateGuestInformation}</span>
        </Button>
      </div>
    </div>
  );
};

export default UpdateGuestPhoneNumber;

UpdateGuestPhoneNumber.propTypes = {
  onClose: PropTypes.func.isRequired,
  iso2: PropTypes.string,
  selectedCheck: PropTypes.object,
  onUpdateGuestInformation: PropTypes.func,
};

UpdateGuestPhoneNumber.defaultProps = {
  onClose: () => { },
  iso2: 'us',
  selectedCheck: {},
  onUpdateGuestInformation: () => { },
};
